import sf90PhaserIcon from "../../../../static/images/TSDD/pedals/sf90_phaser.webp"
import VE8Icon from "../../../../static/images/TSDD/pedals/ve8.webp"
import dinoCompIcon from "../../../../static/images/TSDD/pedals/dino_comp.webp"
import od296Icon from "../../../../static/images/TSDD/pedals/od296.webp"




const SF90 = {
  id: "pedal-1",
  name: "SF-90 Phaser",
  subtitle: "Classic Phaser",
  image: sf90PhaserIcon,
  tags: ["Phaser"],
  modes: [
    {
      id: "tight-rhythm",
      name: "Tight Rhythm",
      description:
        "Fast, percussive overdrive tuned for tight palm mutes and chugs without flubby lows.",
      audio: "/assets/audio/pedals/cobalt-drive-tight-rhythm.mp3",
      icon: sf90PhaserIcon,
    },
  ],
}

const VE8 = {
  id: "pedal-2",
  name: "VE-8 Graphic EQ Pedal",
  subtitle: "8-band Graphic EQ with built in overdrive",
  image: VE8Icon,
  tags: ["EQ", "Boost", "Drive"],
  modes: [
    {
      id: "tight-rhythm",
      name: "Tight Rhythm",
      description:
        "Fast, percussive overdrive tuned for tight palm mutes and chugs without flubby lows.",
      audio: "/assets/audio/pedals/cobalt-drive-tight-rhythm.mp3",
      icon: VE8Icon,
    },
  ],
}


const DINO = {
  id: "pedal-3",
  name: "Dino Compressor",
  subtitle: "Simple yet effective · Extreme Sustain",
  image: dinoCompIcon,
  tags: ["Compression"],
  modes: [
    {
      id: "tight-rhythm",
      name: "Tight Rhythm",
      description:
        "Fast, percussive overdrive tuned for tight palm mutes and chugs without flubby lows.",
      audio: "/assets/audio/pedals/cobalt-drive-tight-rhythm.mp3",
      icon: dinoCompIcon,
    },
  ],
}


const OD296 = {
  id: "pedal-4",
  name: "OD296 Speciale Overdrive",
  subtitle: "Fat Drive · Toggleable Clean Boost",
  image: od296Icon,
  tags: ["Clean Boost", "Overdrive"],
  modes: [
    {
      id: "tight-rhythm",
      name: "Tight Rhythm",
      description:
        "Fast, percussive overdrive tuned for tight palm mutes and chugs without flubby lows.",
      audio: "/assets/audio/pedals/cobalt-drive-tight-rhythm.mp3",
      icon: od296Icon,
    },
  ],
}

export const PEDALS = [
  SF90,
  VE8,
  DINO,
  OD296
];